import { useEffect } from "react";
import { SmoothScroll } from "../components/SmoothScroll";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { CountdownSection } from "../components/CountdownSection";
import { BookingSection } from "../components/BookingSection";
import { FeedbackSection } from "../components/FeedbackSection";
import { Footer } from "../components/Footer";

export default function Landing() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && /^[A-Za-z0-9]{4,12}$/.test(ref)) {
      try { localStorage.setItem("rt_ref", ref.toUpperCase()); } catch {}
    }
  }, []);
  return (
    <SmoothScroll>
      <div className="noise" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <CountdownSection />
        <BookingSection />
        <FeedbackSection />
      </main>
      <Footer />
    </SmoothScroll>
  );
}
